module.exports = __webpack_public_path__ + "static/img/home_fiveScene_flourthIllustration_img.cc4a074.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home_fiveScene_flourthIllustration_img.png
// module id = eroX
// module chunks = 0